"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Clip = _interopRequireDefault(require("../../Clip"));

require("../styles/_clips.scss");

var _When = _interopRequireDefault(require("../../../../../../../../../common/components/When/When"));

var _UploadButton = _interopRequireDefault(require("../../UploadButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SortableGrid = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children,
      setRef = _ref.setRef;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: setRef,
    className: "asset-selection__assets"
  }, children);
});

var Clips = /*#__PURE__*/function (_Component) {
  _inherits(Clips, _Component);

  var _super = _createSuper(Clips);

  function Clips() {
    var _this;

    _classCallCheck(this, Clips);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setGridDragAnimation", function (el) {
      if (!el) {
        return;
      } // The animation library requires a DOM node
      // eslint-disable-next-line react/no-find-dom-node


      _this._gridRef = _reactDom.default.findDOMNode(el);
    });

    return _this;
  }

  _createClass(Clips, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSortEnd = _this$props.onSortEnd,
          onSortStart = _this$props.onSortStart,
          isOver = _this$props.isOver,
          clips = _this$props.clips,
          onChangeClipIndex = _this$props.onChangeClipIndex,
          onDragOver = _this$props.onDragOver,
          canUpdateVideo = _this$props.canUpdateVideo,
          toggleSourceFiles = _this$props.toggleSourceFiles,
          onBrowseFiles = _this$props.onBrowseFiles,
          clipProps = _objectWithoutProperties(_this$props, ["onSortEnd", "onSortStart", "isOver", "clips", "onChangeClipIndex", "onDragOver", "canUpdateVideo", "toggleSourceFiles", "onBrowseFiles"]);

      return /*#__PURE__*/_react.default.createElement(SortableGrid, {
        onSortEnd: onSortEnd,
        onSortStart: onSortStart,
        axis: "xy",
        setRef: this.setGridDragAnimation,
        disableKeyboardInteraction: true,
        pressDelay: 150
      }, /*#__PURE__*/_react.default.createElement(_When.default, {
        isTruthy: canUpdateVideo
      }, /*#__PURE__*/_react.default.createElement(_UploadButton.default, {
        onSourceFiles: toggleSourceFiles,
        onBrowseFiles: onBrowseFiles
      })), clips.map(function (clip, index) {
        return /*#__PURE__*/_react.default.createElement(_Clip.default, _extends({
          key: clip.clipId,
          clip: clip,
          index: index,
          clipsLength: clips.length,
          onChangeClipIndex: onChangeClipIndex,
          onDragOver: isOver ? onDragOver(clip.clipId) : void 0,
          isOver: isOver,
          assetId: clip.assetId,
          canUpdateVideo: canUpdateVideo
        }, clipProps));
      }));
    }
  }]);

  return Clips;
}(_react.Component);

exports.default = Clips;